const TOKEN_KEY = 'api_token';

/**
 * Manage the how Access Tokens are being stored and retreived from storage.
 *
 * Current implementation stores to localStorage. Local Storage should always be
 * accessed through this instace.
**/
const TokenService = {
    getToken() {
        return localStorage.getItem(TOKEN_KEY)
    },

    saveToken(token) {
        localStorage.setItem(TOKEN_KEY, token)
    },

    removeToken() {
        localStorage.removeItem(TOKEN_KEY)
    },

    getPayload(name) {
        let JWT = this.getToken();

        if(!JWT) {
            return undefined;
        }

        let tokenArr = JWT.split('.');

        if(!tokenArr) {
            return undefined;
        }

        let decodedToken = atob( tokenArr[1] || '' );
        let parsedToken = JSON.parse(decodedToken);

        return name ? parsedToken[name] : parsedToken;
    }
}

export default TokenService;